"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import React, { useEffect } from "react";
import supabase from "@/utils/supabase-browser";
const ModalContext = React.createContext(null);
ModalContext.displayName = "ModalContext";
export const useModalContext = () => {
  return React.useContext(ModalContext);
};

/**
 * This component listens for changes to the user's session and refreshes the page when it changes.
 * This is used to update the UI when the user logs in or out for security reasons.
 */
export function SupabaseListener(t0) {
  const $ = _c(5);
  const {
    accessToken
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== accessToken || $[1] !== router) {
    t1 = () => {
      const {
        data: authListener
      } = supabase.auth.onAuthStateChange((event, session) => {
        console.log(`Auth event: ${event}`);
        console.log(`Session info: ${JSON.stringify(session)}`);
        if (accessToken && !session?.access_token) {
          router.push("/login");
        } else {
          if (session?.access_token && !accessToken) {
            console.log("logged in");
            router.push("/app");
          } else {
            if (session?.access_token !== accessToken) {
              router.refresh();
            }
          }
        }
      });
      return () => {
        authListener.subscription.unsubscribe();
      };
    };
    $[0] = accessToken;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== accessToken) {
    t2 = [accessToken];
    $[3] = accessToken;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  return null;
}